const INITIAL_STATE = {
  tryRedirect: false,
  showFilters: true
};

const SearchTimeData = {
  INITIAL_STATE,
}

export default SearchTimeData;